import { createFileRoute } from "@tanstack/react-router";
import { SearchTermsPage } from "~/pages/SearchTerms/SearchTermsPage";

export const Route = createFileRoute("/_app/search-terms/")({
  component: SearchTermsPage,
});
